@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Space+Grotesk:wght@300;400;500;600;700&family=Manrope:wght@300;400;500;600;700&family=Playfair+Display:wght@400;500;600;700&display=swap');

@import "tailwindcss";

@theme {
  /* Colors */
  --color-gold-50: #fdf9f0;
  --color-gold-100: #f9f0db;
  --color-gold-200: #f0dcb8;
  --color-gold-300: #e5c28a;
  --color-gold-400: #d9a55f;
  --color-gold-500: #c98a3a;
  --color-gold-600: #a46d2e;
  --color-gold-700: #7c5325;
  --color-gold-800: #5a3d1d;
  --color-gold-900: #382414;

  --color-dark-900: #0f0f0f;
  --color-dark-800: #1a1a1a;
  --color-dark-700: #252525;
  --color-dark-600: #333333;

  /* Gray scale for text */
  --color-gray-100: #f3f4f6;
  --color-gray-200: #e5e7eb;
  --color-gray-300: #d1d5db;
  --color-gray-400: #9ca3af;
  --color-gray-500: #6b7280;
  --color-gray-600: #4b5563;
  --color-gray-700: #374151;
  --color-gray-800: #1f2937;
  --color-gray-900: #111827;

  /* Basic colors */
  --color-white: #ffffff;
  --color-black: #000000;

  /* Font families - Ultra clean modern, same for all */
  --font-sans: 'Space Grotesk', 'Inter', system-ui, sans-serif;
  --font-display: 'Space Grotesk', 'Inter', system-ui, sans-serif;

  /* Animations */
  --animate-fade-in: fadeIn 0.5s ease-out;
  --animate-slide-up: slideUp 0.5s ease-out;
  --animate-scale-in: scaleIn 0.3s ease-out;

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  @keyframes slideUp {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
  }

  @keyframes scaleIn {
    0% { opacity: 0; transform: scale(0.95); }
    100% { opacity: 1; transform: scale(1); }
  }
}

:root {
  --background: 0 0% 6%;
  --foreground: 0 0% 98%;
  --card: 0 0% 8%;
  --card-foreground: 0 0% 98%;
  --popover: 0 0% 6%;
  --popover-foreground: 0 0% 98%;
  --primary: 38 50% 50%;
  --primary-foreground: 0 0% 6%;
  --secondary: 0 0% 15%;
  --secondary-foreground: 0 0% 98%;
  --muted: 0 0% 15%;
  --muted-foreground: 0 0% 65%;
  --accent: 38 50% 50%;
  --accent-foreground: 0 0% 6%;
  --destructive: 0 84% 60%;
  --destructive-foreground: 0 0% 98%;
  --border: 0 0% 20%;
  --input: 0 0% 20%;
  --ring: 38 50% 50%;
  --radius: 0.5rem;
}

* {
  border-color: hsl(var(--border));
}

html {
  scroll-behavior: smooth;
}

body {
  background-color: #0f0f0f;
  color: white;
  font-family: 'Inter', 'Space Grotesk', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Space Grotesk', 'Inter', system-ui, sans-serif;
  font-weight: 500;
  letter-spacing: -0.02em;
}

@utility text-gradient {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, #e5c28a, #c98a3a);
}

@utility glass {
  background-color: rgba(26, 26, 26, 0.8);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

@utility hover-lift {
  transition: all 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #0f0f0f;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c98a3a;
}

/* Animations */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}
